import React from "react";
import { IonSlide } from "@ionic/react";
import Image from "./image/slide4.1.png";
import "./slide.css";

// const imagecss = {};
// const pstyle = {
//   // marginTop: "2.8r
// };

const Slide4 = (props) => {
  return (
    <IonSlide>
      <img src={Image} alt="給料" />
      <h2>基本給</h2>
      <p>
        基本給とは、あなたの労働に対して支払われるお金です。
        <br />
        本当にあなたの労働と見合ったお金をもらえるのか、しっかり見極めましょう。
      </p>
      <h2>福利厚生</h2>
      <p>
        福利厚生は会社があなたやその家族の暮らしの支えとして用意するものです。
        <br />
        これはあなたの生活のしやすさに繋がり、人生の幸福度を上げる一つの要因になります。
      </p>
    </IonSlide>
  );
};

export default Slide4;

// 【事業内容】事業内容とは会社が取り組んでいる仕事内容です。
// メモをしていくと、自分の実際の働いている姿が想像できるようになるでしょう。

// 【経営理念】経営理念とは会社の目指す方向です。それはそのまま社員の
// 行動指針になるため、自分が従っていくコンパスになります。

// 【基本給】基本給とは、あなたの労働に対して支払われるお金です。本当にあなたの
// 労働と見合ったお金をもらえるのか、しっかり見極めましょう。

// 【福利厚生】福利厚生は会社があなたやその家族の暮らしの支えとして用意するものです。これはあなたの生活のしやすさに繋がり、人生の幸福度を上げる一つの要因になります。

// 【勤務体系】勤務体系には、会社にどのように、どんな時間帯で勤めるかをメモしましょう。
// 趣味や家庭に割ける時間が決まってくるため、あなたのライフスタイルそのものになるでしょう。
// 【自分にあっている点】
// 自分がなぜこの会社で働きたいと感じたかを詳細にメモしておきましょう。
// 複数の会社をメモすると、どの会社が自分に合っているのかが見えてきます。
